import { useState, useEffect } from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import { useLocation } from 'react-router-dom';
import NetworkSelection from './networkSelection';
import CloudConfiguration from './cloudConfiguration';
import Urls from '../../../utils/util';
import { CreateStakingNetworkPayload } from '../../../services/payloadTypes';
import { createStakingNetwork } from '../../../services/apisService';
import {
  NodeDataZoneTypes,
  NetworkDataZoneTypes,
  DefaultObjectType,
  CloudConfigDataZoneTypes,
} from '../declaration';
import CloudInfo from '../../../utils/cloudInfo';
import Loading from '../../../components/common/loader';
import Badge from '../../addNode/components/Badge';
import { toCapitalize } from '../../../utils/helper';

interface InstanceType {
  name: string;
  type: string;
  blockchainInputs: {
    network: string;
    nodeType: string;
    cloudId: string;
    cloudType: string,
    regionId: string,
    regionName: string,
    continentType: string,
  }
}

interface ConfigInfraType {
  managedHosting: boolean;
  cloudId: string;
}
interface NodeConfigType {
  cloudType: string;
  count: number;
  nodeType: string;
  planCode: string;
  nodeValue: string;
}

interface Attribute {
  addon_code?: string;
  attribute_name?: string;
  selection_type?: string;
  attributeValue?: string;
  visibilityOnCard?: boolean;
}

const CreateStakingNetworksBody = () => {
  const [pagenumber, setPageNumber] = useState(0);
  const [networkDataZone, setNetworkDataZone] = useState(
    {} as NetworkDataZoneTypes,
  );
  const [nodeDataZone, setNodeDataZone] = useState([] as NodeDataZoneTypes[]);
  const [cloudConfigDataZone, setCloudConfigDataZone] = useState(
    {} as CloudConfigDataZoneTypes,
  );
  const [defaultObject, setDefaultObject] = useState({} as DefaultObjectType);
  const [nodeCount, setNodeCount] = useState(0);
  const [isDisable, setIsDisable] = useState<boolean>(false);
  const [nodeConfiguration, setNodeConfiguration] = useState(
    {} as NodeConfigType,
  );
  const [managedHosting, setManagedHosting] = useState<boolean>(false);
  const [cloudId, setCloudId] = useState<string>('');
  const [first, setFirst] = useState<boolean>(true);
  const [redirectionUrl, setRedirectionUrl] = useState<string>('');
  const [showLoader, setShowLoader] = useState(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [createNetResMsg, setCreateNetResMsg] = useState<string>('');
  const [isClose, setIsClose] = useState<boolean>(false);
  const location = useLocation();
  const [addOnCodes, setAddOnCodes] = useState([] as string[]);
  const [protocolInfo, setProtocolInfo] = useState({
    protocolId: '',
    networkType: '',
    continentType: '',
    regionId: '',
    regionName: '',
  });
  const getInfraDetail = (key: string) => CloudInfo.getInfraDetails(key);

  const paths = [
    { name: 'Dashboard', path: Urls.getDashboardUrl() },
    { name: 'Dedicated Validator Nodes', path: Urls.getStakingNetworksUrl() },
  ];

  const prev = () => {
    if (pagenumber === 0) {
      setFirst(true);
      setPageNumber(0);
    } else {
      setFirst(false);
      setStepDeactive(pagenumber);
      setPageNumber(pagenumber - 1);
      if (pagenumber === 0) {
        setFirst(true);
      }
    }
  };
  const nextP = () => {
    setFirst(false);
    if (pagenumber === 2) {
      setPageNumber(2);
    } else {
      setPageNumber(pagenumber + 1);
    }
  };
  const resetStep = () => {
    const s1 = document.getElementById('step1');
    if (s1) {
      s1.style.borderBottom = '0px solid #FFF';
    }
    const s2 = document.getElementById('step2');
    if (s2) {
      s2.style.borderBottom = '0px solid #FFF';
    }
    const s4 = document.getElementById('step4');
    if (s4) {
      s4.style.borderBottom = '0px solid #FFF';
    }
  };

  const continueNext = () => {
    window.open(redirectionUrl, '_self');
  };

  const setStepActive = (n: number) => {
    for (let i: number = 1; i <= n + 1; i += 1) {
      const step = `step${i.toString()}${i.toString()}`;
      const ss: HTMLElement | null = document.getElementById(step);
      if (ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#04AA6D';
      }
      if (i === n + 1 && ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#FFC542';
      } else if (ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#FFC542';
      }
    }
  };
  const getNodeConfiguration = () => {
    const params: any = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop: any) => searchParams.get(prop),
    });
    const { count, planCode, attr } = params;
    const paramArr = JSON.parse(attr);
    let infraType = '';
    let nodeType = '';
    let nodeValue = '';

    const addOnArr: string[] = [];
    for (let i = 0; paramArr && i < paramArr.length; i += 1) {
      if (paramArr[i].addon_code && paramArr[i].addon_code.length > 0) {
        addOnArr.push(paramArr[i].addon_code);
      }
      if (paramArr[i].selection_type === 'typeOfInfra') {
        infraType = paramArr[i].attribute_name;
      }
      if (paramArr[i].selection_type === 'nodeType') {
        nodeType = paramArr[i].attribute_name;
        nodeValue = paramArr[i].attributeValue;
      }
    }
    if (infraType) {
      const configInfraDetail: ConfigInfraType | string = getInfraDetail(infraType);
      if (typeof configInfraDetail !== 'string' && configInfraDetail) {
        setManagedHosting(configInfraDetail.managedHosting);
        setCloudId(configInfraDetail.cloudId);
      }
      setNodeConfiguration({
        nodeType,
        cloudType: infraType,
        count,
        planCode,
        nodeValue,
      });
    }
    setAddOnCodes(addOnArr);
  };
  const setStepDeactive = (n: number) => {
    const s = n + 1;
    const step = `step${s.toString()}${s.toString()}`;
    const ss = document.getElementById(step);
    if (ss) {
      ss.style.opacity = '0.5';
      ss.style.backgroundColor = 'rgba(23, 23, 23, 0.1)';
    }
  };

  useEffect(() => {
    getNodeConfiguration();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const attrParam = queryParams.get('attr');
    const protocolId = queryParams.get('protocolId');
    const regionId = queryParams.get('regionId') || '';
    const regionName = queryParams.get('regionName') || '';

    if (attrParam) {
      try {
        const decodedAttrParam = decodeURIComponent(attrParam);
        const attributes: Attribute[] = JSON.parse(decodedAttrParam);

        const fetchAttributeValue = (attributesParam: Attribute[], type: string): string => {
          const attribute = attributesParam.find((attr) => attr.selection_type === type);
          return attribute ? (attribute.attributeValue as string) : '';
        };

        setProtocolInfo({
          protocolId: protocolId as string, // retain the previous value
          networkType: fetchAttributeValue(attributes, 'networkType'),
          continentType: fetchAttributeValue(attributes, 'continentType'),
          regionId,
          regionName,
        });
      } catch (error) {
        console.error('Failed to parse attributes:', error);
      }
    }
  }, [location.search]);

  const submit = async () => {
    setIsDisable(true);
    setShowLoader(true);
    let tempList = [];
    if (managedHosting) {
      tempList = new Array<string>(nodeCount).fill('manageHosting');
    } else {
      tempList = cloudConfigDataZone.instanceArr;
    }
    const obj = {
      network: protocolInfo.networkType as string,
      nodeType: nodeConfiguration.nodeValue,
      cloudId: cloudConfigDataZone.cloudId,
      cloudType: nodeConfiguration.cloudType,
      regionId: cloudConfigDataZone.regionId,
      regionName: cloudConfigDataZone.regionName,
      continentType: protocolInfo.continentType,
    };
    const nodeArray: InstanceType[] = [];
    nodeArray.push({
      name: cloudConfigDataZone.nodeName,
      type: cloudConfigDataZone.instanceType,
      blockchainInputs: obj,
    });
    const mega: CreateStakingNetworkPayload = {
      networkName: networkDataZone.networkName,
      credId: cloudConfigDataZone.cloudAccount,
      cloud: cloudConfigDataZone.cloudId,
      region: cloudConfigDataZone.regionId,
      workspaceId: networkDataZone.workspaceId,
      deploymentType: networkDataZone.deploymentType,
      managedHosting,
      instanceArray: nodeArray,
      projectId: cloudConfigDataZone.gcpProjectId,
      addOnCodes,
    };
    const response: any = await createStakingNetwork({ ...mega });
    setShowLoader(false);
    if (response) {
      setIsDisable(false);
      setModalShow(true);
      if (response.success) {
        setIsClose(false);
        setCreateNetResMsg(response.data.message);
        setRedirectionUrl(response.data.redirectionUrl);
      } else {
        setIsClose(true);
        setIsDisable(false);
        setCreateNetResMsg(response.message);
      }
    } else {
      setIsClose(true);
      setIsDisable(false);
      setModalShow(true);
      setCreateNetResMsg('Error creating network');
    }
  };
  const getInstanceArr = () => {
    const obj = [];
    for (let i = 0; i < nodeCount; i += 1) {
      obj.push(nodeDataZone[i].nodeName);
    }
    return obj;
  };
  const showZone = () => {
    const s1: HTMLElement | null = document.getElementById('step1');
    const s4 = document.getElementById('step3');
    switch (pagenumber) {
      case 0:
        resetStep();
        setStepActive(pagenumber);
        if (s1) {
          s1.style.borderBottom = '2px solid #0062FF';
        }
        return (
          <NetworkSelection
            defaultObject={defaultObject}
            setDefaultObject={setDefaultObject}
            last={false}
            submit={submit}
            first={first}
            prev={prev}
            networkDataZone={networkDataZone}
            setNetworkDataZone={setNetworkDataZone}
            nextPage={nextP}
          />
        );
      case 1:
        resetStep();
        setStepActive(pagenumber);
        if (s4) {
          s4.style.borderBottom = '2px solid #0062FF';
        }
        return (
          <CloudConfiguration
            last
            submit={submit}
            cloudConfigDataZone={cloudConfigDataZone}
            setCloudConfigDataZone={setCloudConfigDataZone}
            first={first}
            prev={prev}
            managedHosting={managedHosting}
            cloudId={cloudConfigDataZone.cloudId}
            continentType={protocolInfo.continentType as string}
            protocolId={protocolInfo.protocolId as string}
            regionId={protocolInfo.regionId as string}
            nextPage={nextP}
            isDisable={isDisable}
            nodeNames={getInstanceArr()}
            nodeCount={nodeCount}
            regionName={protocolInfo.regionName as string}
          />
        );
      default:
        return (
          <NetworkSelection
            defaultObject={defaultObject}
            setDefaultObject={setDefaultObject}
            last={false}
            networkDataZone={networkDataZone}
            submit={submit}
            first={first}
            prev={prev}
            setNetworkDataZone={setNetworkDataZone}
            nextPage={nextP}
          />
        );
    }
  };
  return (
    <section className="px-5 col-12">
      <div className="mt-3">
        <div className="row">
          <div className="col-lg-3 col-xl-9 col-sm-12 col-xs-12 cursor">
            <p className="mt-3 breadcrumb-item mx-1 all-color">
              <span>
                <b>Node Configurations -</b>
              </span>
              <span className="mx-2 text-muted">
                {`${nodeConfiguration.cloudType || 'loading'},`}
              </span>
              <span className="text-muted">
              {`${nodeConfiguration.nodeType || 'loading'},`}
              </span>
              <span className="mx-2 text-muted">
                {`${
                  toCapitalize(protocolInfo.networkType) || 'loading'
                },`}
              </span>
              <span className="text-muted">
                {`${
                  toCapitalize(protocolInfo.continentType) || 'loading'
                }`}
              </span>
            </p>
          </div>
          <div className="col-lg-3 col-xl-3 col-sm-12 col-xs-12 cursor">
            <p className="mt-3 breadcrumb-item all-color">
              <span>
                <b>Available:</b>
              </span>
              <span className="mx-2 text-muted">{`${nodeConfiguration.count} Nodes`}</span>
            </p>
          </div>
        </div>
        <div className="col-lg-3 col-xl-6 col-sm-12 col-xs-12 cursor">
          <Breadcrumb
            prefixLink={paths}
            activeLink="Deploy"
            textSize={13}
          />
        </div>
        {/* network list starts here */}
        <div className="card mt-5">
          <div className="card-body">
            <div className="navbar" style={{ justifyContent: 'left' }}>
              <h6 className="mt-4 ms-4">
                <div
                  className="borderline border-margin paddingbottom"
                  id="step1"
                >
                  <span className="step" id="step11" />
                  <span className="mx-2">Network</span>
                </div>
              </h6>
              <h6 className="mt-4 ms-4">
                <div className="border-margin paddingbottom" id="step3">
                  <span className="step" id="step22" />
                  <span className="mx-2">Cloud Configuration</span>
                </div>
              </h6>
            </div>
            <hr
              className="mt-4 choose-border"
              style={{ marginTop: '-18px !important' }}
            />
            {showLoader && <Loading />}
            {showZone()}
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Status"
        visibleFooter
        visibleFooterCloseButton={isClose}
        visibleHeaderCloseIcon={false}
        visibleConfirmBtn={redirectionUrl !== ''}
        confirmBtnText="Continue"
        onConfirm={continueNext}
        confirmBtnClassName=""
      >
        <Badge resMsg={createNetResMsg} />
      </Modal>
    </section>
  );
};
export default CreateStakingNetworksBody;
